import React from 'react';
import { FaReceipt, FaSearch, FaSignOutAlt, FaUserCircle } from 'react-icons/fa';
import './TopMenu.scss';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useGetRestaurantByIdQuery } from '../../store/restaurant/restaurantApi';
import { selectUserSelectedRestaurantId } from '../../store/shared/selectors/auth.selectors';
import { AuthLogin } from '../../login/login';
import { useModal } from '../../providers/ModalProvider/ModalProvider';
import { useAppDispatch } from '../../store/hooks';
import { api } from '../../store/commonApi';

export const TopMenu = (): JSX.Element => {
	const selectedRestaurantId = useSelector(selectUserSelectedRestaurantId);
	const navigate = useNavigate();
	const { isAuthenticated, logout } = useAuth0();
	const { openModal } = useModal();
	const dispatch = useAppDispatch();

	const target = typeof window !== 'undefined' ? window.location.origin + window.location.pathname + window.location.search + window.location.hash : '/';

	const { data: restaurant } = useGetRestaurantByIdQuery(selectedRestaurantId);

	const navigateToSessionSummary = (): void => {
		navigate('/session/summary');
	};

	const handleLoginClick = (): void => {
		if (!isAuthenticated) {
			const closeModal = openModal(
				<AuthLogin
					onClose={(): void => {
						closeModal();
					}}
					onLogin={(): void => {
						closeModal();
						dispatch(api.util.invalidateTags([{ type: 'Order', id: 'LIST' }, { type: 'Cart' }]));
					}}
				/>
			);
		}
	};

	return (
		<div className="topMenuContainer">
			<div className="restaurantLogo">
				<img src="/images/hetziTuki.png" alt="Restaurant Logo" />
			</div>
			<div className="restaurantInfo">
				<h1 className="restaurantName">{restaurant?.name}</h1>
				<p className="restaurantAddress">יוחנן הורקנוס 3, ירושלים</p>
			</div>
			<div className="iconsContainer">
				{isAuthenticated ? (
					<div className="topMenuIcon" onClick={(): Promise<void> => logout({ logoutParams: { returnTo: target } })}>
						<FaSignOutAlt />
					</div>
				) : (
					<div className="topMenuIcon" onClick={handleLoginClick}>
						<FaUserCircle />
					</div>
				)}
				<div className="topMenuIcon">
					<FaSearch />
				</div>
				<div className="topMenuIcon" onClick={navigateToSessionSummary}>
					<FaReceipt />
				</div>
			</div>
		</div>
	);
};
